export default {
  auth: true,
  security: true,
  slug: 'security',
}
